/**
 * Client-side mirror of the WHS sliding scale used in rhiCalculator.ts.
 * Kept here so the Profile component can highlight which rounds are "used"
 * without making an extra API call.
 */
export function getSlidingScaleParams(roundCount: number): { useBest: number; adjustment: number } {
    if (roundCount < 3) return { useBest: 0, adjustment: 0 };
    if (roundCount === 3) return { useBest: 1, adjustment: -2.0 };
    if (roundCount === 4) return { useBest: 1, adjustment: -1.0 };
    if (roundCount === 5) return { useBest: 1, adjustment: -1.0 };
    if (roundCount === 6) return { useBest: 2, adjustment: -1.0 };
    if (roundCount >= 7 && roundCount <= 8) return { useBest: 2, adjustment: 0 };
    if (roundCount >= 9 && roundCount <= 11) return { useBest: 3, adjustment: 0 };
    if (roundCount >= 12 && roundCount <= 14) return { useBest: 4, adjustment: 0 };
    if (roundCount >= 15 && roundCount <= 16) return { useBest: 5, adjustment: 0 };
    if (roundCount === 17) return { useBest: 6, adjustment: 0 };
    if (roundCount === 18) return { useBest: 7, adjustment: 0 };
    if (roundCount === 19) return { useBest: 8, adjustment: -1.0 };
    return { useBest: 8, adjustment: 0 };
}
